<template>
  <a-card :bordered="false">
    <div style="margin-bottom: 15px;">
      <a-button type="primary" :disabled="dataList.length>0" @click="openModel">添加供应商</a-button>
      <a-button style="margin-left: 15px;" icon="setting" @click="openBindModel">商品绑定</a-button>
    </div>
    <a-table
      :columns="getColumns()"
      :rowKey="(record) => record.accountId"
      :dataSource="dataList"
      :pagination="false"
    >
      <template slot="action" slot-scope="text,record">
        <a @click="editEvent(record)">编辑</a>
      </template>
    </a-table>
    <a-modal title="商品绑定" width="550px" :footer="null" :visible="dialogVisible" @cancel="handleCancel">
      <a-form-model ref="ruleFormPro" :model="ruleFormPro" :rules="proRules" :label-col="labelCol"
                    :wrapper-col="wrapperCol">
        <a-form-model-item label="商品ID" prop="productId">
          <a-input v-model.trim="ruleFormPro.productId" :disabled="true" style="max-width: 280px;" :maxLength="20"
                   placeholder="请输入商品ID"></a-input>
          <a-button style="margin-left: 15px;" @click="showSelectedDialog = true">选择商品</a-button>
        </a-form-model-item>
        <a-form-model-item label="票型ID" prop="optionId">
          <a-select v-model="ruleFormPro.optionId" placeholder="请选择票型" allowClear style="max-width: 280px;">
            <a-select-option v-for="item in optionList" :key="item.optionId" :value="item.optionId">
              {{ item.optionName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 20,offset: 4 }">
          <a-button type="primary" @click="onSubmit" :loading="submitLoading">保存</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal :title="title" width="650px" :footer="null" :visible="visible" @cancel="handleCancel">
      <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="供应商名称" prop="supplyName">
          <a-input v-model.trim="ruleForm.supplyName" :maxLength="20" placeholder="请输入供应商名称"></a-input>
        </a-form-model-item>
        <a-form-model-item label="appId" prop="appId">
          <a-input v-model.trim="ruleForm.appId" placeholder="appId" :maxLength="100"></a-input>
        </a-form-model-item>
        <a-form-model-item label="key" prop="appSecret">
          <a-input v-model.trim="ruleForm.appSecret" placeholder="请输入key" :maxLength="100"></a-input>
        </a-form-model-item>
        <a-form-model-item label="url" prop="url">
          <a-input v-model.trim="ruleForm.url" placeholder="请输入url" :maxLength="100"></a-input>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 20,offset: 4 }">
          <a-button type="primary" @click="handleSubmit" :loading="submitLoading" style="width: 180px;">保存设置
          </a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <selected-product-dialog
      :show="showSelectedDialog"
      ref="pageList"
      :itemNames="['search_proId','search_proName']"
      :query-params="selectedQueryParams"
      :requestPromise="loadPromise"
      row-key="proId"
      @close="showSelectedDialog=false"
      :columns="getGoodsColumns()"
    >
      <a-form-item label="商品ID" slot="search_proId" v-bind="currentDialogLayout">
        <a-input v-model="selectedQueryParams.proId" style="width: 170px" placeholder="请输入商品ID"></a-input>
      </a-form-item>
      <a-form-item label="商品名称" slot="search_proName" v-bind="currentDialogLayout">
        <a-input v-model="selectedQueryParams.proName" style="width: 170px" placeholder="请输入商品名称"></a-input>
      </a-form-item>
      <template slot="proTypeSlot" slot-scope="rowItem">{{ rowItem.text|productTypeName }}</template>
      <template slot="action" slot-scope="rowItem">
        <a-button type="primary" @click="onSelectedResult(rowItem.record)">选择</a-button>
      </template>
    </selected-product-dialog>
  </a-card>
</template>

<script>
import GuWeiMixins from '@/views/service/serviceProvider/guWei/mixins/GuWeiMixins'
import SelectedProductDialog from '@/customComponents/SelectedProductDialog/SelectedProductDialog'

export default {
  name: 'GuWeiAccount',
  mixins: [GuWeiMixins],
  components: {
    SelectedProductDialog
  },
  data() {
    return {
      loadPromise: params => this.getProductListPromise(params),
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      title: '',
      visible: false,
      dialogVisible: false,
      submitLoading: false,
      ruleForm: {
        supplyName: '',// 供应商名称
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId,
        accountId: 0,
        appId: '',
        appSecret: '',
        url: ''
      },
      ruleFormPro: {
        productId: '',
        optionId: undefined,
        accountId: 0
      },
      rules: {
        supplyName: [{ required: true, message: '请输入供应商名称', trigger: 'blur' }],
        appId: [{ required: true, message: '请输入appId', trigger: 'blur' }],
        appSecret: [{ required: true, message: '请输入key', trigger: 'blur' }],
        url: [{ required: true, message: '请输入url', trigger: 'blur' }]
      },
      proRules: {
        productId: [{ required: true, message: '请输入商品Id', trigger: 'blur' }],
        optionId: [{ required: true, message: '请选择票型', trigger: 'blur' }]
      },
      dataList: [],
      accountId: 0,
      showSelectedDialog: false,
      selectedQueryParams: {
        proId: '',
        proName: '',
        proType: 1,
        proSource: 0,
        proStatus: 0
      },
      currentDialogLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 }
      },
      optionList: []
    }
  },
  mounted() {
    this.getAccountDetail()
  },
  methods: {
    getAccountDetail() {
      const params = {
        merchantId: this.$store.getters.userInfo.merchantId,// 商户ID ,
        platformId: this.getPlatformConfig().platformId// 平台ID ,
      }
      this.getHttpServices().getServerApiService().post('api/gw/account/info', params).then(res => {
        this.dataList = res && res.accountId ? [res] : []
        this.accountId = res && res.accountId ? res.accountId : 0
      }).catch(err => {
        this.getLogUtils().logWithTag(err)
      })
    },
    //编辑事件
    editEvent(record) {
      this.title = '编辑供应商'
      this.getLogUtils().logWithTag('editEvent== record', record)
      this.ruleForm = record
      this.visible = true
    },
    onSubmit() {
      this.$refs.ruleFormPro.validate(valid => {
        if (valid) {
          this.onSubmitPro()
        } else {
          this.getLogUtils().logWithTag('错误', 'error submit!!')
          return false
        }
      })
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('错误', 'error submit!!')
          return false
        }
      })
    },
    submitData() {
      this.submitLoading = true
      let params = JSON.parse(JSON.stringify(this.ruleForm))
      params.merchantId = this.$store.getters.userInfo.merchantId// 商户ID
      params.platformId = this.getPlatformConfig().platformId// 平台ID
      this.getHttpServices().getServerApiService().post('api/gw/account/save', params).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        let textStr = this.ruleForm.accountId != 0 ? '编辑' : '新增'
        this.$message.success(textStr + '供应商')
        this.getAccountDetail()
        this.visible = false
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    onSubmitPro() {
      this.submitLoading = true
      let params = JSON.parse(JSON.stringify(this.ruleFormPro))
      params.accountId = this.accountId
      params.merchantId = this.$store.getters.userInfo.merchantId// 商户ID
      params.platformId = this.getPlatformConfig().platformId// 平台ID
      this.getHttpServices().getServerApiService().post('api/gw/product/save', params).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('商品绑定成功')
        this.dialogVisible = false
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    openModel() {
      this.title = '新建供应商'
      this.visible = true
    },
    handleCancel() {
      this.visible = false
      this.dialogVisible = false
    },
    openBindModel() {
      this.dialogVisible = true
      this.getProductInfo()
    },
    getColumns() {
      return [
        {
          title: 'ID',
          key: 'accountId',
          dataIndex: 'accountId'
        },
        {
          title: '供应商名称',
          key: 'supplyName',
          dataIndex: 'supplyName'
        },
        {
          title: 'appId',
          key: 'appId',
          dataIndex: 'appId'
        },
        {
          title: 'key',
          key: 'appSecret',
          dataIndex: 'appSecret'
        },
        {
          title: 'url',
          key: 'url',
          dataIndex: 'url'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '100px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    getGoodsColumns() {
      return [
        {
          title: '商品ID',
          dataIndex: 'proId',
          width: '100px'
        },
        {
          title: '商品名称',
          dataIndex: 'proName'
        },
        {
          title: '商品分类',
          dataIndex: 'proType',
          width: '100px',
          scopedSlots: { customRender: 'proTypeSlot' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '100px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    getProductListPromise(params) {
      return this.getHttpServices().getProService().post('api/v2/productManage/findProductList', params)
    },
    //商品数据点击
    onSelectedResult(record) {
      this.selectedProduct = record
      this.ruleFormPro.productId = record.proId
      this.showSelectedDialog = false
      this.getOptionList(record.proId)
    },
    getOptionList(proId) {
      if (!proId) {
        return
      }
      const params = {
        limitDto: { pageNum: 1, pageSize: 1000 },
        proId
      }
      this.getHttpServices().getProService().post('api/v2/productManage/findOptionList', params).then(res => {
        this.getLogUtils().logWithTag('getOptionList', res)
        this.optionList = res && res.data && res.data.length > 0 ? res.data : []
        this.ruleFormPro.optionId = undefined
        console.error('this.ruleFormPro--列表', this.ruleFormPro)
      }).catch(err => {
        this.getLogUtils().logWithTag(err)
      })
    },
    getProductInfo() {
      const params = {
        merchantId: this.$store.getters.userInfo.merchantId,// 商户ID
        platformId: this.getPlatformConfig().platformId// 平台ID
      }
      this.getHttpServices().getServerApiService().post('api/gw/product/info', params).then(res => {
        this.getLogUtils().logWithTag('getProductInfo', res)
        this.ruleFormPro = res && res.productId && res.optionId ? { ...res } : {
          productId: '',
          optionId: undefined,
          accountId: 0
        }
        console.error('this.ruleFormPro--查询', this.ruleFormPro)
        this.getOptionList(res.productId)
      }).catch(err => {
        this.getLogUtils().logWithTag(err)
      })
    }
  }
}
</script>
<style scoped></style>
